import { jsx as _jsx } from "react/jsx-runtime";
import MuiPopper from '@mui/material/Popper';
import * as React from 'react';
export const Popper = React.forwardRef((muiProps, ref) => {
    return _jsx(MuiPopper, { ref: ref, ...muiProps });
});
